import styled from 'styled-components';
import { Callout } from '../../callout';

export const StyledCallout = styled(Callout)`
    overflow: hidden;
    height: 200px;
    min-width: 150px;
`;

export const StyledCalloutContent = styled.div.attrs(() => ({
    className: String('ap-compactTimePicker-calloutContent')
}))`
    height: 100%;
    overflow: hidden;
`;
